import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconCheckboxUnchecked$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconCheckboxUnchecked extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '0f5c9d9004bea33230c282f8e4382d035f55f4f5', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '0cc4815bd4efaa8325934b4baf84009c8b69a0bd', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'c16134b8d7a9916791de2982e1ed25ac09852771', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M17.5 4.5v13h-13v-13zM3.5 3a.5.5 0 0 0-.5.5v15a.5.5 0 0 0 .5.5h15a.5.5 0 0 0 .5-.5v-15a.5.5 0 0 0-.5-.5z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-checkbox-unchecked", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-checkbox-unchecked"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-checkbox-unchecked":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconCheckboxUnchecked$1);
            }
            break;
    } });
}

const CosmosIconCheckboxUnchecked = CosmosIconCheckboxUnchecked$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconCheckboxUnchecked, defineCustomElement };
